var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic/shop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.083 6.948C20.716 6.354 20.08 6 19.382 6H6.582L5.965 3.737C5.846 3.302 5.451 3 5 3H3C2.447 3 2 3.448 2 4C2 4.552 2.447 5 3 5H4.236L7.035 15.263C7.154 15.698 7.549 16 8 16H17C17.379 16 17.725 15.786 17.895 15.447L21.171 8.894C21.483 8.269 21.45 7.542 21.083 6.948ZM7.5 17.9998C6.672 17.9998 6 18.6708 6 19.4998C6 20.3288 6.672 20.9998 7.5 20.9998C8.328 20.9998 9 20.3288 9 19.4998C9 18.6708 8.328 17.9998 7.5 17.9998ZM16 19.4998C16 18.6708 16.672 17.9998 17.5 17.9998C18.328 17.9998 19 18.6708 19 19.4998C19 20.3288 18.328 20.9998 17.5 20.9998C16.672 20.9998 16 20.3288 16 19.4998Z",
    fill: "#1890FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.fe4388fcc6befbb93a25de2cbe0518a5.svg";
export { ForwardRef as ReactComponent };